import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=62b9ba7e&scoped=true&"
import script from "./password-reset.vue?vue&type=script&lang=js&"
export * from "./password-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9ba7e",
  null
  
)

export default component.exports